// extracted by mini-css-extract-plugin
export default {"alertBox":"Alert_alertBox__PInG-","success":"Alert_success__u5UJ3","error":"Alert_error__EMWxY"};